import { render, staticRenderFns } from "./TestLogin.vue?vue&type=template&id=c875e35a&scoped=true&"
import script from "./TestLogin.vue?vue&type=script&lang=js&"
export * from "./TestLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c875e35a",
  null
  
)

export default component.exports